import 'react-app-polyfill/ie11';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { ThreeDots } from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import { Button, TextField, Typography } from '@material-ui/core';
import { Paper } from '@material-ui/core';

function DisneyActivate(props) {

  const [loading, setLoading] = React.useState();
  const [customerNo, setCustomerNo] = React.useState();
  const [zipCode, setZipCode] = React.useState();
  const [errMsg, setErrMsg] = React.useState();
  const [responseOk, setResponseOk] = React.useState();

  useEffect(() => {

  }, []);


  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: '#f5f5f5'
    }}>
      <Paper elevation={3} style={{
        padding: '30px',
        width: '400px',
        maxWidth: '90vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
          marginTop: '10px',
          marginBottom: '10px'
        }}>
          <img
            src={require('./images/Sappa_Green.png')}
            style={{ height: '50%', maxHeight: '60px' }}
          />
          <img
            src={require('./images/selection_disneyplus.png')}
            style={{ height: '50%', maxHeight: '60px' }}
          />
        </div>

        <h4 style={{ margin: "10px", textAlign: 'center' }}>
          Välkommen att aktivera ditt Disney+ hos Sappa
        </h4>

        <TextField
          value={customerNo}
          defaultValue=''
          onChange={(e) => setCustomerNo(e.target.value)}
          id="customerno"
          label="Kundnummer"
          variant="outlined"
          fullWidth
          style={{ margin: "10px 0" }}
        />
        <TextField
          value={zipCode}
          defaultValue=''
          onChange={(e) => setZipCode(e.target.value)}
          id="zipcode"
          label="Postnummer"
          variant="outlined"
          fullWidth
          style={{ margin: "10px 0" }}
        />

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          <Button
            size='medium'
            variant='contained'
            disabled={loading}
            color='primary'
            style={{ margin: "10px" }}
            onClick={() => {

              if (customerNo == null || zipCode == null) {
                setErrMsg("Du måste ange kundnummer och postnummer.");
                return;
              }

              setLoading(true);
              setErrMsg("");
              setResponseOk(false);

              let endpoint = 'https://partner.sappa.se/api/disneyplus';
              //let endpoint = 'https://localhost:44325/api/disneyplus';


              fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Authorization': '97959AD6-C24A-409C-BBDC-6B851A023B87',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  customerNo: customerNo,
                  zipCode: zipCode
                })
              })
                .then(response => {
                  setResponseOk(true);
                  return response.text();
                })
                .then(data => {
                  var result = (data || "").trim();

                  // Ta bort eventuella omslutande citattecken om servern returnerar JSON-string
                  if (result.startsWith('"') && result.endsWith('"')) {
                    result = result.substring(1, result.length - 1);
                  }

                  if (result.toLowerCase().startsWith("https://")) {
                    window.location.replace(result);
                  }
                  else {
                    setErrMsg(result);
                  }
                  setLoading(false);
                })
                .catch(
                  exp => {
                    setLoading(false);
                    setErrMsg("Ett fel uppstod, försök igen senare.");
                    console.log(exp);
                  }
                );

            }}>Aktivera</Button>
          <Button
            size='medium'
            variant='contained'
            color='default'
            style={{ margin: "10px" }}
            href='/'
          >Avbryt</Button>
        </div>

        <div style={{ color: 'red', margin: "10px", textAlign: 'center' }}>{errMsg}</div>
      </Paper>
    </div>
  );
}

export default DisneyActivate;